<div class="tab-pane show active fade details-view-results trial-notifications" id="trial-notifications" role="tabpanel">
  <div class="notifications-tab-row">
    <app-segment-control #segmentControl (segmentIndexChange)="segmentIndexChanged($event)" [style]="SegmentStyle.Secondary">
      @if (diaryEnabled) {
        <app-segment-control-item text="E-Diary" [active]="true"></app-segment-control-item>
      }
      <app-segment-control-item text="Visits" [active]="!diaryEnabled"></app-segment-control-item>
    </app-segment-control>
    <div class="tab-row-actions">
      <app-button variant="info" text="Settings" size="sm" (clicked)="notificationCentreForm.show()" />
    </div>
  </div>

  @if (currentSegment === 0 && diaryEnabled) {
    @if (diaryEnabled && diaryForms.length > 0) {
      <div class="diaries-tab-row">
        <ul class="nav secondary-tabs">
          @for (diary of diaryForms; track diary.id) {
            <li class="nav-item">
              <a class="nav-link"
                 [class.active]="selectedDiaryFormId === diary.id"
                 (click)="selectDiaryForm(diary.id)">
                {{ getDiaryDisplayName(diary) }}
              </a>
            </li>
          }
        </ul>
      </div>
    }

    <div class="trial-notifications-head">
      <h2>Notifications</h2>

      <div class="buttons">
        @if (diaryEnabled) {
          <app-button variant="secondary" text="+ Add Notification" size="sm" (clicked)="addEdiaryNotification()" />
        }
      </div>
    </div>

    @if (loading || ediaryNotifications.length > 0) {
      <table>
        <thead>
        <tr>
          <th>Active</th>
          <th>Type</th>
          <th>Name</th>
          <th>When</th>
          <th class="column-mandatory">Mandatory</th>
          <th class="column-check">App</th>
          <th class="column-check">Email</th>
          <th></th>
        </tr>
        </thead>
        @if (loading) {
          <tbody class="body-loading">
          @for (item of [].constructor(loadingRowCount); track $index) {
            <tr>
              <td><ngx-skeleton-loader class="d-block" [theme]="{ 'margin-bottom': '0' }"></ngx-skeleton-loader></td>
              <td><ngx-skeleton-loader class="d-block" [theme]="{ 'margin-bottom': '0' }"></ngx-skeleton-loader></td>
              <td><ngx-skeleton-loader class="d-block" [theme]="{ 'margin-bottom': '0' }"></ngx-skeleton-loader></td>
              <td><ngx-skeleton-loader class="d-block" [theme]="{ 'margin-bottom': '0' }"></ngx-skeleton-loader></td>
              <td><ngx-skeleton-loader class="d-block" [theme]="{ 'margin-bottom': '0' }"></ngx-skeleton-loader></td>
              <td><ngx-skeleton-loader class="d-block" [theme]="{ 'margin-bottom': '0' }"></ngx-skeleton-loader></td>
            </tr>
          }
          </tbody>
        } @else {
          <tbody>
            @for (notification of ediaryNotifications; track notification.id; let i = $index) {
              <tr>
                <td class="column-enabled">
                  @if (rowBusyIds.includes(notification.id)) {
                    <div class="checkbox-spinner">
                      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    </div>
                  }
                  @else {
                    <div class="checkbox-wrap">
                      <label class="checkbox" [class.checked]="notification.enabled">
                        <input type="checkbox" value="true" (change)="onToggleNotification(notification)">
                        <span></span>
                      </label>
                    </div>
                  }
                </td>
                <td>{{ NotificationType[notification.notificationType] }}</td>
                <td>{{ notification.name }}</td>
                <td>{{ notification.when }}</td>
                <td class="column-mandatory"><i class="far" [class.fa-check]="notification.mandatoryNotification" [class.fa-times]="!notification.mandatoryNotification"></i></td>
                <td class="column-check"><i class="far" [class.fa-check]="notification.appNotificationEnabled" [class.fa-times]="!notification.appNotificationEnabled"></i></td>
                <td class="column-check"><i class="far" [class.fa-check]="notification.emailNotificationEnabled" [class.fa-times]="!notification.emailNotificationEnabled"></i></td>
                <td class="column-actions">
                  <div class="notification-actions">
                    <app-button text="Remove" variant="info" size="sm" (click)="onRemove(notification)" />
                    <app-button text="Edit" variant="secondary" size="sm" (clicked)="notificationFormModal.update(notification.id)"  />
                  </div>
                </td>
              </tr>
            }
          </tbody>
        }
      </table>
    }

    @if (!loading && ediaryNotifications.length === 0) {
      <div class="no-results inside">
        <div class="inner">
          <div class="image">
            <img src="assets/img/no-results-illustration.png" alt="No results found" />
          </div>
          <div class="content">
            <h2>No Results Found</h2>
            <p>There are no Notifications assigned to this trial.</p>
          </div>
        </div>
      </div>
    }
  }

  @if (currentSegment === 1 || (currentSegment === 0 && !diaryEnabled)) {
    <div class="trial-notifications-head">
      <h2>Notifications</h2>

      <div class="buttons">
        <app-button variant="secondary" text="+ Add Notification" size="sm" (clicked)="addVisitNotification()" />
      </div>
    </div>

    @if (loading || visitNotifications.length > 0) {
      <table>
        <thead>
        <tr>
          <th>Active</th>
          <th>Type</th>
          <th>Name</th>
          <th>When</th>
          <th class="column-mandatory">Mandatory</th>
          <th class="column-check">App</th>
          <th class="column-check">Email</th>
          <th></th>
        </tr>
        </thead>
        @if (loading) {
          <tbody class="body-loading">
          @for (item of [].constructor(loadingRowCount); track $index) {
            <tr>
              <td><ngx-skeleton-loader class="d-block" [theme]="{ 'margin-bottom': '0' }"></ngx-skeleton-loader></td>
              <td><ngx-skeleton-loader class="d-block" [theme]="{ 'margin-bottom': '0' }"></ngx-skeleton-loader></td>
              <td><ngx-skeleton-loader class="d-block" [theme]="{ 'margin-bottom': '0' }"></ngx-skeleton-loader></td>
              <td><ngx-skeleton-loader class="d-block" [theme]="{ 'margin-bottom': '0' }"></ngx-skeleton-loader></td>
              <td><ngx-skeleton-loader class="d-block" [theme]="{ 'margin-bottom': '0' }"></ngx-skeleton-loader></td>
              <td><ngx-skeleton-loader class="d-block" [theme]="{ 'margin-bottom': '0' }"></ngx-skeleton-loader></td>
            </tr>
          }
          </tbody>
        } @else {
          <tbody>
            @for (notification of visitNotifications; track notification.id; let i = $index) {
              <tr>
                <td class="column-enabled">
                  @if (rowBusyIds.includes(notification.id)) {
                    <div class="checkbox-spinner">
                      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    </div>
                  }
                  @else {
                    <div class="checkbox-wrap">
                      <label class="checkbox" [class.checked]="notification.enabled">
                        <input type="checkbox" value="true" (change)="onToggleNotification(notification)">
                        <span></span>
                      </label>
                    </div>
                  }
                </td>
                <td>{{ NotificationType[notification.notificationType] }}</td>
                <td>{{ notification.name }}</td>
                <td>{{ notification.when }}</td>
                <td class="column-mandatory"><i class="far" [class.fa-check]="notification.mandatoryNotification" [class.fa-times]="!notification.mandatoryNotification"></i></td>
                <td class="column-check"><i class="far" [class.fa-check]="notification.appNotificationEnabled" [class.fa-times]="!notification.appNotificationEnabled"></i></td>
                <td class="column-check"><i class="far" [class.fa-check]="notification.emailNotificationEnabled" [class.fa-times]="!notification.emailNotificationEnabled"></i></td>
                <td class="column-actions">
                  <div class="notification-actions">
                    <app-button text="Remove" variant="info" size="sm" (click)="onRemove(notification)" />
                    <app-button text="Edit" variant="secondary" size="sm" (clicked)="notificationFormModal.update(notification.id)"  />
                  </div>
                </td>
              </tr>
            }
          </tbody>
        }
      </table>
    }

    @if (!loading && visitNotifications.length === 0) {
      <div class="no-results inside">
        <div class="inner">
          <div class="image">
            <img src="assets/img/no-results-illustration.png" alt="No results found" />
          </div>
          <div class="content">
            <h2>No Results Found</h2>
            <p>There are no Notifications assigned to this trial.</p>
          </div>
        </div>
      </div>
    }
  }
</div>

<app-trial-notification-centre-form #notificationCentreForm [trialId]="trialId"></app-trial-notification-centre-form>

<app-trial-notification-form #notificationFormModal [trialId]="trialId" [selectedDiaryFormId]="selectedDiaryFormId" (updated)="onNotificationTemplatesUpdated($event)"></app-trial-notification-form>

<app-confirm-action-modal #confirmModal (confirmed)="onConfirmRemove($event)"></app-confirm-action-modal>
